'use strict';

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/isNaN.js
// module id = 249
// module chunks = 0